export const STEP_UPLOAD = 0;
export const STEP_HEADERS = 1;
export const STEP_FEATURES = 2;
export const STEP_OPTIONALS = 3;
export const STEP_CHECKOUT = 4;
export const STEP_SUBMIT = 5;
